import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiUsers, FiShield, FiClock } = FiIcons;

const TrustSignals = ({ className = "" }) => {
  return (
    <div className={`flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-8 ${className}`}>
      <div className="flex items-center space-x-2">
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <SafeIcon key={i} icon={FiStar} className="h-5 w-5 text-yellow-400 fill-current" />
          ))}
        </div>
        <span className="font-medium">4.7/5 Rating</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiUsers} className="h-5 w-5 text-primary-200" />
        <span className="font-medium">600,000+ Businesses Trust Us</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiClock} className="h-5 w-5 text-secondary-200" />
        <span className="font-medium">Instant Online Coverage</span>
      </div>
      
      <div className="flex items-center space-x-2">
        <SafeIcon icon={FiShield} className="h-5 w-5 text-green-200" />
        <span className="font-medium">A+ Rated Protection</span>
      </div>
    </div>
  );
};

export default TrustSignals;